import React from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { F0Icon, F0Select, F0SelectItemObject } from '@factorialco/f0-react'
import { CheckCircle, CrossedCircle } from '@factorialco/f0-react/icons/app'

import i18n from 'modules/core/lib/i18n'

import { Element } from 'modules/forms/lib/Element'
import { Answer } from 'modules/forms/lib/types'

interface DropdownElementQuestionProps {
  element: Element
  onChange?: (answer: Answer) => void
  disabled?: boolean
  showCorrectAnswerIcons?: boolean
}

/**
 * Question component for DropdownElement
 */
const DropdownElementQuestion: React.FC<DropdownElementQuestionProps> = ({
  element,
  onChange,
  disabled,
  showCorrectAnswerIcons = true,
}) => {
  const currentChoice = element.answer?.options?.[0] || ''
  const [selectedValue, setSelectedValue] = React.useState<string>(currentChoice)

  const handleChange = (optionId: string) => {
    setSelectedValue(optionId)
    onChange?.({
      answer: optionId,
      options: [optionId],
    })
  }

  const options: F0SelectItemObject<string>[] = element.options.map((option) => ({
    label: option.label,
    value: option.id ?? '',
  }))

  const selectedOption = element.options.find((opt) => opt.id === selectedValue)

  return (
    <Box gap="s8" width="full">
      <F0Select<string>
        label=""
        aria-label={element.label || i18n.t('forms.render.select_option')}
        options={options}
        value={selectedValue}
        onChange={handleChange}
        disabled={disabled}
      />
      {showCorrectAnswerIcons && selectedOption && (
        <>
          {selectedOption.isCorrect ? (
            <>
              <F0Icon icon={CheckCircle} size="md" color="#10B881" />
            </>
          ) : (
            <>
              <F0Icon icon={CrossedCircle} size="md" color="#FF5C4B" />
            </>
          )}
        </>
      )}
    </Box>
  )
}

export default DropdownElementQuestion
